import { FormField, IconButton } from '@melio/penny';

type DeleteLineItemProps = {
  IndexNumber: number;
  testId: string;
  onClick: VoidFunction;
  ariaLabel?: string;
};

export const DeleteLineItem = ({ IndexNumber, testId, onClick, ariaLabel }: DeleteLineItemProps) => (
  <FormField
    labelProps={{ label: '', isHidden: true }}
    render={() => (
      <IconButton
        data-testid={`${testId}-${IndexNumber}`}
        icon="delete"
        onClick={onClick}
        variant="naked"
        aria-label={ariaLabel ?? 'Delete line item'}
      />
    )}
  />
);
